import React, { useCallback } from 'react'
import { Tooltip, Typography } from '@material-ui/core'
import { useIntl } from 'react-intl'
import { getDisplayName } from 'app/auth/store/reducers/user.query'
import {
  humanizedTimeIndicator,
  getDateTimeDiff,
} from 'libs/humanizedTimeIndicator/humanizedTimeIndicator'
import Assets from 'app/configs/assetConfigs'
import { makeStyles } from '@material-ui/styles'
import * as R from 'ramda'
import moment from 'moment'
import { useDefaultLanguage } from 'commons/useDefaultLanguage'
import clsx from 'clsx'

export const getDiffTimeInDay = (performDate) => {
  const { diffTimeInDays } = getDateTimeDiff(moment(), moment(performDate))
  return diffTimeInDays
}

export const useTooltipTitle = () => {
  const { formatMessage } = useIntl()
  const defaultLanguage = useDefaultLanguage()
  const getHumanizedDateTime = useCallback(
    (dateTime) => {
      return humanizedTimeIndicator({
        timestamp: dateTime,
        languageCode: R.prop('code', defaultLanguage),
        formatMessage,
      })
    },
    [defaultLanguage, formatMessage],
  )
  const createTitle = useCallback(
    (person, performDate) => ({
      displayName: R.ifElse(
        R.isNil,
        R.always(
          formatMessage({
            id: 'notificationTimeline.card.canceled.system.title',
          }),
        ),
        R.compose(
          getDisplayName,
          R.pickAll(['firstName', 'lastName', 'email']),
        ),
      )(person),
      humanizedDateTime: getHumanizedDateTime(performDate),
      dateDiff: getDiffTimeInDay(performDate),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getHumanizedDateTime],
  )

  return createTitle
}

const useStyles = makeStyles((theme) => ({
  negativeText: {
    color: theme.palette.negative.main,
  },
}))

export const TooltipStatus = ({ status, ...props }) => {
  const classes = useStyles()
  return (
    <Tooltip {...props}>
      <div className={clsx('flex cursor-default', 'flex-row')}>
        <img src={Assets.unsent} alt="unsent" />
        <Typography
          className={clsx(
            classes.negativeText,
            'text-xs font-semibold ltr:pl-1 rtl:pr-1 self-center',
          )}
        >
          {status}
        </Typography>
      </div>
    </Tooltip>
  )
}
